import { render, staticRenderFns } from "./whole.vue?vue&type=template&id=22a72ce7&scoped=true&"
import script from "./whole.vue?vue&type=script&lang=js&"
export * from "./whole.vue?vue&type=script&lang=js&"
import style0 from "./whole.vue?vue&type=style&index=0&id=22a72ce7&prod&lang=scss&"
import style1 from "./whole.vue?vue&type=style&index=1&id=22a72ce7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a72ce7",
  null
  
)

export default component.exports